<div class="nmi-pos-mgr">

  <!-- ── Register new device ─────────────────────────────────────────────── -->
  <div class="nmi-pos-mgr__register">
    <h4 class="nmi-pos-mgr__section-title">Register New Terminal</h4>
    <p class="nmi-pos-mgr__hint">
      Power on the Lane/3000 terminal to display its registration code, then enter it below.
    </p>

    <div class="nmi-pos-mgr__form">
      <input class="nmi-pos-mgr__input" type="text" [(ngModel)]="registrationCode"
        placeholder="Registration code (shown on terminal)" [disabled]="registering" />
      <input class="nmi-pos-mgr__input" type="text" [(ngModel)]="deviceNickname"
        placeholder="Nickname (e.g. Front Desk)" [disabled]="registering" />
      <button class="nmi-pos-mgr__btn nmi-pos-mgr__btn--primary"
        [disabled]="registering || !registrationCode.trim() || !deviceNickname.trim()"
        (click)="registerDevice()">
        {{ registering ? 'Registering...' : 'Register' }}
      </button>
    </div>
    <p *ngIf="registerError" class="nmi-pos-mgr__error">{{ registerError }}</p>
  </div>

  <!-- ── Device list ─────────────────────────────────────────────────────── -->
  <div class="nmi-pos-mgr__list-section">
    <div class="nmi-pos-mgr__list-header">
      <h4 class="nmi-pos-mgr__section-title">Registered Terminals</h4>
      <button class="nmi-pos-mgr__btn nmi-pos-mgr__btn--secondary" (click)="loadDevices()" [disabled]="loading">
        Refresh
      </button>
    </div>

    <div *ngIf="loading" class="nmi-pos-mgr__loading">Loading...</div>

    <div *ngIf="!loading && devices.length === 0" class="nmi-pos-mgr__empty">
      No devices registered yet.
    </div>

    <table *ngIf="!loading && devices.length > 0" class="nmi-pos-mgr__table">
      <thead>
        <tr>
          <th>Nickname</th>
          <th>Terminal ID</th>
          <th>Status</th>
          <th>Connected</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let device of devices; trackBy: trackByDeviceId">

          <!-- Nickname (normal / edit mode) -->
          <td>
            <span *ngIf="editingDeviceId !== device.poi_device_id">{{ device.device_nickname }}</span>
            <input *ngIf="editingDeviceId === device.poi_device_id"
              class="nmi-pos-mgr__inline-input"
              [(ngModel)]="editNickname" [disabled]="saving" />
          </td>

          <td class="nmi-pos-mgr__mono">{{ device.poi_device_id }}</td>

          <td>
            <span class="nmi-pos-mgr__badge"
              [class.nmi-pos-mgr__badge--active]="device.registration_status === 'active'">
              {{ device.registration_status }}
            </span>
          </td>

          <td>
            <span class="nmi-pos-mgr__dot"
              [class.nmi-pos-mgr__dot--on]="device.is_connected"
              [class.nmi-pos-mgr__dot--off]="!device.is_connected">
            </span>
          </td>

          <td class="nmi-pos-mgr__actions-cell">

            <!-- Normal: edit + remove -->
            <ng-container *ngIf="editingDeviceId !== device.poi_device_id && confirmRemoveId !== device.poi_device_id">
              <button class="nmi-pos-mgr__btn nmi-pos-mgr__btn--icon"
                (click)="startEdit(device)" title="Edit nickname">&#9998;</button>
              <button class="nmi-pos-mgr__btn nmi-pos-mgr__btn--danger"
                (click)="promptRemove(device.poi_device_id)">Remove</button>
            </ng-container>

            <!-- Edit mode: save + cancel -->
            <ng-container *ngIf="editingDeviceId === device.poi_device_id">
              <button class="nmi-pos-mgr__btn nmi-pos-mgr__btn--secondary"
                (click)="cancelEdit()">Cancel</button>
              <button class="nmi-pos-mgr__btn nmi-pos-mgr__btn--primary"
                [disabled]="saving || !editNickname.trim()"
                (click)="saveEdit(device.poi_device_id)">
                {{ saving ? 'Saving...' : 'Save' }}
              </button>
            </ng-container>

            <!-- Confirm remove -->
            <ng-container *ngIf="confirmRemoveId === device.poi_device_id">
              <span class="nmi-pos-mgr__confirm-text">
                Remove "{{ device.device_nickname }}"? It will need to be re-registered.
              </span>
              <button class="nmi-pos-mgr__btn nmi-pos-mgr__btn--secondary"
                [disabled]="removing" (click)="cancelRemove()">Cancel</button>
              <button class="nmi-pos-mgr__btn nmi-pos-mgr__btn--danger"
                [disabled]="removing" (click)="confirmRemove(device.poi_device_id)">
                {{ removing ? 'Removing...' : 'Yes, Remove' }}
              </button>
            </ng-container>

          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>
